import { useCallback } from "react";

import { useMsal } from "@azure/msal-react";

import { queryCache } from "api";

import { useUserDetailsStore } from "../store";
import { msalInstance, loginRequest } from "./auth-config";

export const useLoginAzureAd = () => {
  const { instance, inProgress, accounts } = useMsal();

  const accountCount = accounts.length;

  return useCallback(async () => {
    if (inProgress === "none" && accountCount === 0) {
      await instance.loginRedirect(loginRequest);
    }
  }, [instance, inProgress, accountCount]);
};

export const useTokenCookieExchange = () => {
  const logout = useUserDetailsStore((state) => state.logout);
  const { instance, accounts, inProgress } = useMsal();
  const updateUserDetails = useUserDetailsStore(
    (actions) => actions.updateADUser
  );

  const userAccount = accounts[0];

  return useCallback(async () => {
    if (
      (inProgress === "none" || inProgress === "handleRedirect") &&
      userAccount
    ) {
      try {
        await updateUserDetails(instance, userAccount);
      } catch (e) {
        await instance.logout();
        await logout();
        return;
      }
    }
  }, [updateUserDetails, instance, userAccount, inProgress, logout]);
};

export const logout = async () => {
  try {
    await msalInstance.loginRedirect();
  } catch (e) {}
};

export const useLogout = () => {
  const { instance } = useMsal();
  const logout = useUserDetailsStore((actions) => actions.logout);

  return useCallback(async () => {
    queryCache.clear();

    try {
      await logout();
    } catch (e) {}
    try {
      await instance.logout();
    } catch (e) {}
  }, [logout, instance]);
};

export default useLoginAzureAd;
